export default __webpack_public_path__ + "static/media/line-seq-swap-arrow-down-gray.f902ac15.svg";